export default __webpack_public_path__ + "static/media/c002-PPII-3.be0e15d3.svg";